module.exports = __webpack_public_path__ + "static/media/attribution_black_24dp.8590f3ef.svg";